function deepMerge (target, source) {
  const result = Object.assign({}, target)
  for (const key in source) {
    if (!Object.prototype.hasOwnProperty.call(source, key)) continue
    if (
      source[key] &&
      typeof source[key] === 'object' &&
      !Array.isArray(source[key]) &&
      typeof target[key] === 'object' &&
      !Array.isArray(target[key])
    ) {
      result[key] = deepMerge(target[key], source[key])
    } else {
      result[key] = source[key]
    }
  }
  return result
}

function getComponentKey (component) {
  return component.key || component.label
}

function insertAtOrder(array, component, order) {
  if (typeof order !== 'number' || order < 0 || order >= array.length) {
    array.push(component)
  } else {
    array.splice(order, 0, component)
  }
  return array
}

function applyCustomizationByKeyPath (form, keyPath, customization) {
  const keys = keyPath.split('.')
  if (getComponentKey(form) === keys[0]) {
    if (keys.length === 1) {
      return deepMerge(form, customization)
    }
    if (!Array.isArray(form.components)) {
      form.components = []
    }
    const nextKey = keys[1]
    let found = false
    let newComponents = form.components.map(component => {
      if (getComponentKey(component) === nextKey) {
        found = true
        return applyCustomizationByKeyPath(component, keys.slice(1).join('.'), customization)
      }
      return component
    })

    if (!found) {
      if (keys.length === 2) {
        // Adiciona novo campo ao agrupador
        const newComp = Object.assign({
          key: nextKey,
          type: customization.type || 'label',
          style: customization.style || 'xs12'
        }, customization)

        // Se tem order definida, insere na posição
        if (typeof customization.order === 'number' && customization.order >= 0 && customization.order < newComponents.length) {
          newComponents.splice(customization.order, 0, newComp)
        } else {
          newComponents.push(newComp)
        }
      } else {
        // Procura se já existe um agrupador criado anteriormente
        let existingGroup = form.components.find(c => getComponentKey(c) === nextKey)
        if (existingGroup) {
          // Atualiza o agrupador existente recursivamente
          existingGroup = applyCustomizationByKeyPath(existingGroup, keys.slice(1).join('.'), customization)
          newComponents = newComponents.map(c => getComponentKey(c) === nextKey ? existingGroup : c)
        } else {
          // Cria o agrupador intermediário e desce recursivamente
          let newGroup = {
            key: nextKey,
            type: 'panel',
            style: 'xs12',
            components: []
          }
          newGroup = applyCustomizationByKeyPath(newGroup, keys.slice(1).join('.'), customization)
          newComponents.push(newGroup)
        }
      }
    } else if (typeof customization.order === 'number' && keys.length === 2) {
      // Reposiciona apenas se for um componente direto (não um painel)
      const order = customization.order
      if (order >= 0 && order < newComponents.length) {
        const currentIndex = newComponents.findIndex(c => getComponentKey(c) === nextKey)
        if (currentIndex !== -1 && currentIndex !== order) {
          const [component] = newComponents.splice(currentIndex, 1)
          newComponents.splice(order, 0, component)
        }
      }
    }

    return Object.assign({}, form, { components: newComponents })
  }
  return form
}

function parseCustomizations(customizations) {
  if (typeof customizations === 'string') {
    try {
      return JSON.parse(customizations)
    } catch (e) {
      return {}
    }
  } else if (customizations && typeof customizations === 'object') {
    return customizations
  }
  return {}
}

module.exports = {
  exec: (form, customizations) => {
    const customizationsObj = parseCustomizations(customizations)
    let result = Object.assign({}, form)

    // Primeiro processa customizações sem order
    const customizationsWithoutOrder = {}
    const customizationsWithOrder = {}

    Object.entries(customizationsObj).forEach(([path, customization]) => {
      if (typeof customization.order === 'number') {
        customizationsWithOrder[path] = customization
      } else {
        customizationsWithoutOrder[path] = customization
      }
    })

    // Aplica customizações sem order primeiro
    Object.entries(customizationsWithoutOrder).forEach(([path, customization]) => {
      result = applyCustomizationByKeyPath(result, path, customization)
    })

    // Depois aplica customizações com order
    Object.entries(customizationsWithOrder).forEach(([path, customization]) => {
      result = applyCustomizationByKeyPath(result, path, customization)
    })

    return result
  },
  applyAll: (formsJson, customizations) => {
    const customizationsObj = parseCustomizations(customizations)
    // Garante que components existe e é um array
    const customizedFormsJson = { ...formsJson }
    if (!Array.isArray(customizedFormsJson.components)) {
      customizedFormsJson.components = []
    }
    if (customizedFormsJson.components.length > 0 && customizationsObj && Object.keys(customizationsObj).length > 0) {
      customizedFormsJson.components = customizedFormsJson.components.map(form => {
        if (!form || typeof form !== 'object') return form
        // Agrupa customizações que começam com a key do form
        const formCustomizations = {}
        Object.entries(customizationsObj).forEach(([path, customization]) => {
          if (form.key && (path === form.key || path.startsWith(`${form.key}.`))) {
            formCustomizations[path] = customization
          }
        })
        if (Object.keys(formCustomizations).length > 0) {
          try {
            return module.exports.exec(form, formCustomizations)
          } catch (e) {
            console.error('Erro ao customizar form', form.key, e)
            return form
          }
        }
        return form
      })
    }
    return customizedFormsJson
  }
}



// WEBPACK FOOTER //
// ./functions/shared/formCustomization.js